<template>
  <div>
     <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>水工订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header  @back="goBack"  content="水工订单" v-if="visible"></el-page-header>
    <el-divider v-if="visible"></el-divider>
 <!-- 卡片视图区域 -->
 <el-card>
      <collapse @getDataList="search" :button-text="'search'">


        <collapse-item>
         <span class="Name">表单编号:</span>
          <el-input placeholder="表单编号" v-model="queryInfoparams.params.formNumber" clearable></el-input>
        </collapse-item>

        <collapse-item v-if="this.user.userType === '1'">
            <span>Agent:</span>
            <!-- <el-input placeholder="please input agant" v-model.trim="queryInfoparams.params.agencyName" clearable></el-input> -->
              <el-select v-model="queryInfoparams.params.agencyId" filterable placeholder="" clearable>
                <el-option  v-for="item in agencyList"
                  :key="item.id"
                  :label="item.agencyName"
                  :value="item.id">
              </el-option>
            </el-select>
        </collapse-item>

        <collapse-item>
            <span>Plumber Company:</span>
              <el-select v-model="queryInfoparams.params.companyId" filterable placeholder="" clearable>
                <el-option  v-for="item in companyList"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.id">
                </el-option>
              </el-select>
        </collapse-item>

        <collapse-item>
          <span class="createTime">开始结束时间:</span>
          <el-date-picker
            @change="dateChange"
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="start Date"
            format="yyyy-MM-dd"
            end-placeholder="end Date"
            :picker-options="pickerOptions"
          >></el-date-picker>
        </collapse-item>

   </collapse>
    <el-row type="flex" justify="end">
               <el-col class="searchBtns" :span="6">
                <el-button-group>
                 <el-button plain size="small"  icon="el-icon-share" @click="exportData" >导出</el-button>
                 <el-button plain size="small"  icon="el-icon-check" @click="deleteData" >删除</el-button>                </el-button-group>
               </el-col>
   </el-row>
   <el-table :data="dataList" border stripe @selection-change="handleSelectionChange">
   <el-table-column type="selection" width="55"></el-table-column>
   <el-table-column type="index" label="No."></el-table-column>
   <el-table-column label="表单编号" sortable prop="formNumber" width="160px"></el-table-column>
   <el-table-column label="水工公司" sortable prop="companyName"></el-table-column>
   <el-table-column label="水工姓名" sortable prop="name"></el-table-column>
   <el-table-column label="水工电话" sortable prop="mobile"></el-table-column>
   <el-table-column label="所在城市" sortable prop="address"></el-table-column>
   <el-table-column label="施工详细地址" sortable prop="detailedConstructionAddress"></el-table-column>
   <el-table-column label="订单金额" sortable prop="orderAmount" width="160px"></el-table-column>
   <el-table-column label="订单日期" sortable prop="orderDate" width="160px"></el-table-column>
   <el-table-column label="订单产品明细" sortable prop="productDetails" width="160px"></el-table-column>

    <el-table-column label="操作"  show-overflow-tooltip width="80px" fixed="right" >
      <template slot-scope="scope">
        <div class="btnContainer">
          <!-- 修改按钮 -->
          <el-link
            icon="el-icon-edit"
            @click="showDetail(scope.row)"
          >查看</el-link>
        </div>
      </template>
    </el-table-column>
  </el-table>
    <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <edit-plumber-order
        ref="editPlumberOrderDialog"
        :dialogTableVisible="dialogTableVisible"
        :entity="currentItem"
        @closeDialog="closeDialog"
        :title="'订单详情'"
      ></edit-plumber-order>
 </el-card>

 </div>
</template>

<script>
import db from '@/services/localstorage';
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
import EditPlumberOrder from './EditPlumberOrder.vue'
export default {
    components:{Collapse,CollapseItem,EditPlumberOrder},
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: 'Last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last three month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        user: {},
        agencyList:[],
        companyList:[],
        dialogTableVisible: false,
        currentItem: {},

        queryInfoparams: {
          // 当前页码
          current: 0,
          // 查询参数
          params: {
            formNumber: "",
            agencyId:"",
            companyId:"",
            orderDateStart: "",
            orderDateEnd: ""
          },
          // 当前每页显示多少条数据
          size: 10,
          // 排序字段
          sortField: '',
          // ASC  DESC 顺序
          sortOrder: '',
        },
        dataList: [],
        multipleSelection: [],

        total: 0,
        //是否显示header头
        visible:this.$route.query.visible,

        dateRange: '',
      }
    },

    created(){
      var user=db.get("user");
      this.user = user;
      console.log("user:", JSON.stringify(user))

      this.queryInfoparams.params.userType=user.userType;

      this.search()

      if(this.user.userType == '1'){
        this.getAgencyList()
      }
      this.getCompanyList()
    },
    methods: {

      dateChange(value) {
        console.log(value)
        if (value != null && value != undefined) {
          this.queryInfoparams.params.orderDateStart = value[0]
          this.queryInfoparams.params.orderDateEnd = value[1]
        } else {
          this.queryInfoparams.params.orderDateStart = null
          this.queryInfoparams.params.orderDateEnd = null
        }
      },

    //监控checkbox的选择,为entity的所有值
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log('multipleSelection', this.multipleSelection)
    },

    goBack() {
      this.$router.back()
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
        // 获取 查询数据列表
    async getDataList() {
      this.$post('engineerOrder/pageQuery', this.queryInfoparams).then(
          ({ data: res }) => {
            this.dataList = res.records
            this.total = res.total
          }
        )
    },
        // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },

    // 点击按钮 添加
    async exportData() {
       console.log("queryInfoparams:"+this.queryInfoparams.params.userType)

     let res = this.$export("engineerOrder/export",JSON.stringify(this.queryInfoparams),"plumber_information")
    },
    // 批量删除
    async deleteData(){
        this.$confirm('是否确认删除您所选中的所有表单！！！', '温馨提示', {
          confirmButtonText: 'Sure',
          cancelButtonText: 'Cancel',
          customClass: 'submit-box'
        }).then(()=> {
          if (this.multipleSelection && this.multipleSelection.length >0) {
            const ids = this.multipleSelection.map(obj => {
              return obj.id
            }).join(',')
            const that = this
            that.$get(`engineerOrder/deleteOption/${ids}`).then(
              ({ data: res }) => {
                if (res.code == 200) {
                  that.$message({
                    type: 'success',
                    message: '删除成功!'
                  });
                  that.search()
                } else {
                  that.$message.error(res.msg);
                }
              }
            )
          } else {
            this.$message('请先选择要删除的表单');
            return
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    selectHandler(){

    },

    //获取所有的水工公司
    getCompanyList() {
      if(!this.agencyId)
      this.$post('engineerCompany/queryEngineerCompanys', {

      }).then(
        ({ data: res }) => {
          this.companyList = res
          console.log("水工公司",this.companyList)
        }
      )
    },
    //获取所有的代理商
    getAgencyList(){
      this.$post('agent/queryAgents', {}).then(
        ({ data: res }) => {
          this.agencyList = res
          console.log("代理商",this.agencyList)
        }
      )
    },

    showDetail(item){

      this.currentItem = item;
      this.dialogTableVisible = true;

      console.log("item is:", JSON.stringify(item))

    },
    closeDialog(){
      this.currentItem = {};
      this.dialogTableVisible = false;
    },

     async reset() {
       this.queryInfoparams.params.agent='';
       this.queryInfoparams.params.company='';
       this.queryInfoparams.params.name='';
       this.queryInfoparams.params.phone='';
       this.queryInfoparams.params.email='';
    },

   }
  }

</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.collapseBtn {
  height: 40px;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

#el-collapse-head-4510{
  height: auto;
}
.el-col{
  display: flex;
}
.el-date-editor{
   height: auto;
   width:auto;
}
.demonstration1{
  height: auto;
  width:25%;
}
.el-button{
     height: auto;
     width:auto;
}
.left{
  width:auto;
}
#el-input__inner{
  width:200px;
}
</style>
